import React, { useState, Fragment } from 'react'
import Modal from '@material-ui/core/Modal'
import IconButton from '@material-ui/core/IconButton'
import CropImage from './CropImage'
import { v4 as uuidv4 } from 'uuid'
import DialogContentText from '@material-ui/core/DialogContentText'

import pic from './man-with-pink-shirt.png'

function getModalStyle() {
  const top = -400
  const left = -100

  return {
    minHeight: `440px`,
    maxWidth: `600px`,
    margin: `auto`,
    backgroundColor: `#fff`,
    padding: `1rem`,
    marginTop: '4rem',
    transform: `translate(-${top}%, -${left}%)`,
    borderRadius: `4px`,
    boxShadow: `0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)`,
    border: `1px gray solid`,
  }
}

function CropImgModal(props) {
  const [modalStyle] = React.useState(getModalStyle)
  const [open, setOpen] = React.useState(false)
  const [userProfilePic, setUserProfilePic] = useState(pic)
  const [editor, setEditor] = useState(null)
  const [scaleValue, setScaleValue] = useState(1)

  const profileImageChange = e => {
    const [file] = Array.from(e.target.files)

    const { type } = file
    if (type.endsWith('jpeg') || type.endsWith('png') || type.endsWith('jpg')) {
      setUserProfilePic(file)
    }
  }
  const onCrop = () => {
    if (editor != null) {
      const canvas = editor.editor.current.getImageScaledToCanvas()
      const id = uuidv4()
      canvas.toBlob(b => {
        props
          .fileStorageRef()
          .child(id)
          .put(b)
          .then(() => {
            props.handleUploadSuccess(id)
          })
          .catch(e => console.log('e', e))
      }, 'image/png')
    }
    setOpen(false)
  }

  const setEditorRef = editor => setEditor({ editor })
  const onScaleChange = scaleValueEvent => {
    const scaleValue = parseFloat(scaleValueEvent.target.value)
    setScaleValue(scaleValue)
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <div>
        <IconButton
          style={{
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '0.875rem',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            lineHeight: '1.75',
            letterSpacing: '0.02857em',
            fontWeight: '500',
            cursor: 'pointer',
            border: '1px solid rgba(0, 161, 228, 0.5)',
            backgroundColor: '#FFFFFF',
            color: '#00A1E4',
            padding: '5px 16px',
            borderRadius: 20,
          }}
          onClick={handleOpen}
        >
          Upload/Edit Account Photo
        </IconButton>
      </div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle}>
          <DialogContentText
            center
            style={{
              textAlign: 'center',
              left: '50%',
            }}
          >
            Upload Your Profile Picture <strong></strong>
          </DialogContentText>
          <input
            type="file"
            accept="image/png, image/jpeg"
            onChange={profileImageChange}
            style={{
              marginLeft: '30%',
              marginTop: '1rem',
              cursor: 'pointer',
              border: '1px solid rgba(0, 161, 228, 0.5)',
              backgroundColor: '#FFFFFF',
              color: '#00A1E4',
              padding: '5px 16px',
              borderRadius: 20,
              textAlign: 'center',
            }}
          />
          <CropImage
            imageSrc={userProfilePic}
            setEditorRef={setEditorRef}
            onCrop={onCrop}
            scaleValue={scaleValue}
            onScaleChange={onScaleChange}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Fragment>
  )
}
export default CropImgModal



// WEBPACK FOOTER //
// ./src/components/crop/CropImgModal.js